import * as React from "react";
import type { SVGProps } from "react";
const SvgLoading = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    viewBox="0 0 21 20"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M4.45 14.438A7.48 7.48 0 0 0 10.5 17.5a7.5 7.5 0 0 0 6.989-4.767l2.324.909A10.01 10.01 0 0 1 10.5 20c-2.88 0-5.6-1.236-7.5-3.39v2.297H.5v-6.97h6.419v2.5zM20.5 1.217v6.97h-6.419v-2.5h2.559A7.48 7.48 0 0 0 10.5 2.5a7.5 7.5 0 0 0-6.989 4.767l-2.324-.909C2.687 2.528 6.386 0 10.5 0c2.88 0 5.6 1.236 7.5 3.39V1.218z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLoading;
